import { FC } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export interface ExperiencesIconIconProps {
  color: string;
}

export const ExperiencesIcon: FC<ExperiencesIconIconProps> = ({ color }) => {
  return (
    <SvgIcon>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M21.9991 10.7137L20.5707 3.57152C20.5373 3.40777 20.4476 3.26091 20.3171 3.15651C20.1866 3.05211 20.0236 2.99678 19.8565 3.00015H16.9996C16.8102 3.00015 16.6285 3.07539 16.4946 3.20934C16.3606 3.34328 16.2854 3.52494 16.2854 3.71437C16.2854 3.90379 16.3606 4.08545 16.4946 4.2194C16.6285 4.35334 16.8102 4.42859 16.9996 4.42859H19.2708L20.4136 10.1424H3.58653L4.72928 4.42859H7.00051C7.18993 4.42859 7.37159 4.35334 7.50554 4.2194C7.63948 4.08545 7.71473 3.90379 7.71473 3.71437C7.71473 3.52494 7.63948 3.34328 7.50554 3.20934C7.37159 3.07539 7.18993 3.00015 7.00051 3.00015H4.14362C3.97653 2.99678 3.81355 3.05211 3.68305 3.15651C3.55255 3.26091 3.46279 3.40777 3.4294 3.57152L2.00096 10.7137C1.99968 10.7375 1.99968 10.7614 2.00096 10.7852C1.99969 10.8089 1.99969 10.8328 2.00096 10.8566V19.4272C2.00096 19.6166 2.07621 19.7983 2.21015 19.9323C2.34409 20.0662 2.52576 20.1414 2.71518 20.1414H9.85739C9.95139 20.142 10.0446 20.124 10.1316 20.0884C10.2186 20.0529 10.2978 20.0005 10.3645 19.9343L12.0001 18.2916L13.6356 19.9272C13.7018 19.9947 13.7806 20.0484 13.8677 20.0851C13.9547 20.1219 14.0482 20.1411 14.1427 20.1414H21.2849C21.4743 20.1414 21.656 20.0662 21.79 19.9323C21.9239 19.7983 21.9991 19.6166 21.9991 19.4272V10.8566C22.0004 10.8328 22.0004 10.8089 21.9991 10.7852C22.0004 10.7614 22.0004 10.7375 21.9991 10.7137ZM20.5707 18.713H14.4355L12.5 16.7775C12.3662 16.6444 12.1852 16.5698 11.9965 16.5698C11.8078 16.5698 11.6268 16.6444 11.493 16.7775L9.56456 18.713H3.4294V11.5708H20.5707V18.713Z'
          fill={color}
        />
      </svg>
    </SvgIcon>
  );
};
